module.exports = __webpack_public_path__ + "static/media/678JulianStNW_2018-06-25_126.3f7e01ba.jpg";